/*************************************************
 * CONSTANTS & GLOBAL CONFIG
 *************************************************/

const CART_TOKEN_KEY = "ohnuts_cart_token";
const CART_ITEMS_KEY = "ohnuts_cart_items";
const MULTI_ADDRESS_KEY = "ohnuts_multi_address_info";

const SINGLE_CART_TOKEN_KEY = "ohnuts_cart_token_single";
const SINGLE_CART_ITEMS_KEY = "ohnuts_cart_items_single";
const SINGLE_ADDRESS_KEY = "ohnuts_single_address_info";

const GUEST_ADDRESS_LIST = "ohnuts_guest_address_list";
const ADDRESS_REMOVAL_KEY = "address-removal-info";

const UPS_GROUND_EXCEPTION_STATES = [];
const SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE = [];
let SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE = [];

const CART_REDIRECT_URL = window.Shopify.routes.root + "cart";
const SINGLE_ADDRESS_SHIPPING_URL = window.Shopify.routes.root + "pages/single-address-shipping";
const SINGLE_ADDRESS_CREATE_URL = window.Shopify.routes.root + "pages/address-create";
const SINGLE_ADDRESS_UPDATE_URL = window.Shopify.routes.root + "pages/address-update";
const ADDRESS_LIST_URL = window.Shopify.routes.root + "pages/address-list";
const MULTI_SHIP_CART_URL = window.Shopify.routes.root + "pages/multi-ship-cart";
const MULTI_SHIP_ADDRESS_URL = window.Shopify.routes.root + "pages/multi-address-shipping";

const SHOPIFY_APP_BASE_URL =
  "https://multi-address-order-30436288b667.herokuapp.com/api";

const CART_ITEM_REQUIRED_PROPERTIES = [
  "variant_id",
  "product_id",
  "quantity",
  "properties",
  "title",
  "image",
  "sku",
  "url",
  "original_price",
  "original_line_price",
  "final_price",
  "final_line_price",
];

const COMPLETE_ADDRESS_REQUIRED_FIELDS = [
  "address1",
  "city",
  "province",
  "country",
];

const EDIT_PEN_SVG = `<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;">
  <mask style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="18">
    <rect x="0.5" width="18" height="18" fill="#D9D9D9"></rect>
  </mask>
  <g>
    <path d="M1.99805 18V15.4875H16.998V18H1.99805ZM4.74811 12.2376H5.64811L12.4855 5.40619L11.5793 4.5L4.74811 11.3376V12.2376ZM3.49805 13.4874V10.8249L12.4731 1.85625C12.5939 1.73537 12.7303 1.64581 12.8824 1.58756C13.0345 1.52919 13.1897 1.5 13.348 1.5C13.5064 1.5 13.6647 1.52919 13.8231 1.58756C13.9814 1.64581 14.1189 1.73744 14.2356 1.86244L15.1292 2.76244C15.2542 2.87494 15.347 3.01038 15.4075 3.16875C15.4679 3.32713 15.498 3.48544 15.498 3.64369C15.498 3.79794 15.4679 3.95106 15.4075 4.10306C15.347 4.25519 15.2542 4.39375 15.1292 4.51875L6.16055 13.4874H3.49805Z" fill="#999999"></path>
  </g>
</svg>`;
const BIN_SVG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;">
  <path d="M20.4375 2.8125H16.9219V2.10938C16.9219 0.946266 15.9756 0 14.8125 0H9.1875C8.02439 0 7.07812 0.946266 7.07812 2.10938V2.8125H3.5625C2.39939 2.8125 1.45312 3.75877 1.45312 4.92188C1.45312 5.856 2.06367 6.64973 2.90648 6.9263L4.16062 22.0658C4.25095 23.1504 5.1743 24 6.26269 24H17.7373C18.8258 24 19.7491 23.1504 19.8395 22.0654L21.0935 6.92625C21.9363 6.64973 22.5469 5.856 22.5469 4.92188C22.5469 3.75877 21.6006 2.8125 20.4375 2.8125ZM8.48438 2.10938C8.48438 1.72167 8.7998 1.40625 9.1875 1.40625H14.8125C15.2002 1.40625 15.5156 1.72167 15.5156 2.10938V2.8125H8.48438V2.10938ZM18.438 21.949C18.4079 22.3105 18.1001 22.5938 17.7373 22.5938H6.26269C5.89992 22.5938 5.59214 22.3105 5.56209 21.9494L4.32628 7.03125H19.6737L18.438 21.949ZM20.4375 5.625H3.5625C3.1748 5.625 2.85938 5.30958 2.85938 4.92188C2.85938 4.53417 3.1748 4.21875 3.5625 4.21875H20.4375C20.8252 4.21875 21.1406 4.53417 21.1406 4.92188C21.1406 5.30958 20.8252 5.625 20.4375 5.625Z" fill="#525252"></path>
  <path d="M9.1862 20.4409L8.48307 9.09715C8.45902 8.70954 8.12354 8.41474 7.73781 8.43888C7.3502 8.46293 7.05549 8.79659 7.07949 9.18415L7.78262 20.5279C7.80573 20.9007 8.11529 21.1876 8.48373 21.1876C8.89093 21.1876 9.21118 20.8446 9.1862 20.4409Z" fill="#525252"></path>
  <path d="M12 8.4375C11.6117 8.4375 11.2969 8.75231 11.2969 9.14062V20.4844C11.2969 20.8727 11.6117 21.1875 12 21.1875C12.3883 21.1875 12.7031 20.8727 12.7031 20.4844V9.14062C12.7031 8.75231 12.3883 8.4375 12 8.4375Z" fill="#525252"></path>
  <path d="M16.2623 8.43887C15.8755 8.41483 15.541 8.70953 15.517 9.09714L14.8139 20.4409C14.7899 20.8285 15.0846 21.1621 15.4722 21.1862C15.86 21.2102 16.1934 20.9153 16.2174 20.5279L16.9206 9.18414C16.9446 8.79653 16.6499 8.46287 16.2623 8.43887Z" fill="#525252"></path>
</svg>`;
const GREEN_ADD_SVG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;">
	<mask style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
		<rect width="24" height="24" fill="#D9D9D9"/>
	</mask>
	<g>
		<path d="M10.6711 13.325H4.51562V10.675H10.6711V4.51953H13.3211V10.675H19.4766V13.325H13.3211V19.4805H10.6711V13.325Z" fill="#3BADA3"/>
	</g>
</svg>`;
const CROSS_SVG = `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;">
	<path d="M4.8 12.0117L4 11.2117L7.2 8.01172L4 4.81172L4.8 4.01172L8 7.21172L11.2 4.01172L12 4.81172L8.8 8.01172L12 11.2117L11.2 12.0117L8 8.81172L4.8 12.0117Z" fill="white"/>
</svg>`;



/*************************************************
 * 1. STORAGE DRIVER
 * Used to abstract localStorage access
 *************************************************/
function storageDriver() {
  return window.localStorage;
}

/*************************************************
 * 2. SAVE DATA INTO STORAGE
 * Clears draft order cache based on flow
 *************************************************/
function saveOhnutsInfo(infoKey, infoValue) {
  const driver = storageDriver();
  driver.setItem(infoKey, infoValue);

  localStorage.removeItem(
    infoKey === MULTI_ADDRESS_KEY
      ? "ohnuts_multi_draft_order_info"
      : "ohnuts_single_draft_order_info"
  );

  hideOhnutsLoadingSpinner();
}

/*************************************************
 * 3. READ DATA FROM STORAGE
 *************************************************/
function getOhnutsInfo(infoKey) {
  return storageDriver().getItem(infoKey);
}

/*************************************************
 * 4. REMOVE DATA FROM STORAGE
 *************************************************/
function removeOhnutsInfo(infoKey) {
  storageDriver().removeItem(infoKey);
}

/*************************************************
 * 5. SHOW SMALL CUSTOM MODAL
 *************************************************/
// function showOhnutsCustomModal(
//   description = "",
//   title = "Multi-address Shipping",
//   btnTxt = "Close",
//   btnLink = "",
//   callback = null,
//   showCloseButton = false
// ) {
//   alert(description);
//   const modal = document.createElement("div");
//   modal.className = "ohnust-cas-modal";

//   const content = document.createElement("div");
//   content.className = "ohnust-cas-modal-content";
//   content.innerHTML = `<h2>${title}</h2><p>${description}</p>`;

//   const btnWrap = document.createElement("div");
//   btnWrap.className = "ohnust-cas-modal-button-container";

//   const mainBtn = document.createElement("button");
//   mainBtn.textContent = btnTxt;
//   mainBtn.className = "ohnust-cas-modal-close-btn";

//   mainBtn.onclick = () => {
//     modal.remove();
//     if (btnLink) {
//       showOhnutsLoadingSpinner();
//       window.location.href = btnLink;
//     }
//     callback && callback();
//   };

//   btnWrap.appendChild(mainBtn);

//   if (showCloseButton) {
//     const closeBtn = document.createElement("button");
//     closeBtn.textContent = "Close";
//     closeBtn.className = "ohnust-cas-modal-close-btn";
//     closeBtn.onclick = () => modal.remove();
//     btnWrap.appendChild(closeBtn);
//   }

//   content.appendChild(btnWrap);
//   modal.appendChild(content);
//   document.body.appendChild(modal);
// }

function showOhnutsCustomModal(
  description = "",
  title = "Multi-address Shipping",
  btnTxt = "Close",
  btnLink = "",
  callback = null,
  showCloseButton = false
) {
  // Create the modal container
  const modal = document.createElement("div");
  modal.classList.add("ohnust-cas-modal");

  // Create modal content
  const modalContent = document.createElement("div");
  modalContent.classList.add("ohnust-cas-modal-content");

  // Add text content inside modal
  modalContent.innerHTML = `<h2>${title}</h2><p>${description}</p>`;

  // Create a button container
  const buttonContainer = document.createElement("div");
  buttonContainer.classList.add("ohnust-cas-modal-button-container");

  // Create a main button
  const mainButton = document.createElement("button");
  mainButton.textContent = btnTxt;
  mainButton.classList.add("ohnust-cas-modal-close-btn");

  // Add main functionality
  mainButton.onclick = function() {
    document.body.removeChild(modal);
    if (btnLink != "") {
      showOhnutsLoadingSpinner();
      window.location.href = btnLink;
    }

    if (callback) {
      callback();
    }
  };

  // Append main button to the button container
  buttonContainer.appendChild(mainButton);

  if (showCloseButton) {
    // Create a close button
    const closeButton = document.createElement("button");
    closeButton.textContent = "Close";
    closeButton.classList.add("ohnust-cas-modal-close-btn");

    // Add close functionality
    closeButton.onclick = function() {
      document.body.removeChild(modal);
    };

    // Append close button to the button container
    buttonContainer.appendChild(closeButton);
  }

  // Append the button container to modal content
  modalContent.appendChild(buttonContainer);

  // Append modal content to modal
  modal.appendChild(modalContent);

  // Append modal to body
  document.body.appendChild(modal);

  // Display the modal
  modal.style.display = "flex";
  modal.style.zIndex = 9999;
}
/*************************************************
 * 6. SHOW LARGE CUSTOM MODAL
 *************************************************/
function showOhnutsLrgCustomModal(
  description = "",
  title = "Multi-address Shipping",
  btnTxt = "Close",
  btnLink = "",
  callback = null,
  showCloseButton = false,
  width = "600px",
  height = "auto",
  backgroundColor = "#ffffff",
  textColor = "#000000"
) {
  const modal = document.createElement("div");
  modal.className = "custom-modal";
  Object.assign(modal.style, {
    position: "fixed",
    inset: "0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,.5)",
    zIndex: 9999,
  });

  const content = document.createElement("div");
  Object.assign(content.style, {
    width,
    height,
    backgroundColor,
    color: textColor,
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center",
  });

  content.innerHTML = `<h2>${title}</h2><p>${description}</p>`;

  const btn = document.createElement("button");
  btn.textContent = btnTxt;
  btn.onclick = () => {
    modal.remove();
    if (btnLink) window.location.href = btnLink;
    callback && callback();
  };

  content.appendChild(btn);
  modal.appendChild(content);
  document.body.appendChild(modal);
}

/*************************************************
 * 7. SHOW LOADING SPINNER
 *************************************************/
function showOhnutsLoadingSpinner() {
  const spinner = document.getElementById("ohnust-cas-overlay-spinner");
  if (spinner) {
    spinner.style.zIndex = 999999;
    spinner.classList.remove("hidden");
  }
}

/*************************************************
 * 8. HIDE LOADING SPINNER
 *************************************************/
function hideOhnutsLoadingSpinner() {
  const spinner = document.getElementById("ohnust-cas-overlay-spinner");
  if (spinner) {
    spinner.style.zIndex = 0;
    spinner.classList.add("hidden");
  }
}


/*************************************************
 * 9. GET MULTI ADDRESS CART INFO
 *************************************************/
function getCartMultiAddressInfo(key = MULTI_ADDRESS_KEY) {
  try {
    return JSON.parse(getOhnutsInfo(key)) || {};
  } catch {
    return {};
  }
}

/*************************************************
 * 10. GET CART ITEMS
 *************************************************/
function getCartItems() {
  try {
    return JSON.parse(getOhnutsInfo(CART_ITEMS_KEY)) || [];
  } catch {
    return [];
  }
}

/*************************************************
 * 11. ADD CLASSES TO ELEMENTS
 *************************************************/
function addClassesToElements(selector, classes) {
  document.querySelectorAll(selector).forEach(el =>
    classes.forEach(cls => el.classList.add(cls))
  );
}

/*************************************************
 * 12. REMOVE CLASSES FROM ELEMENTS
 *************************************************/
function removeClassesFromElements(selector, classes) {
  document.querySelectorAll(selector).forEach(el =>
    classes.forEach(cls => el.classList.remove(cls))
  );
}

/*************************************************
 * 13. INVOICE REDIRECT HANDLER
 *************************************************/
function checkInvoiceUrlAndRedirecttoCheckout(redirectLink) {
  return function () {
    showOhnutsLoadingSpinner();
    setTimeout(() => {
      hideOhnutsLoadingSpinner();
      window.location.href = redirectLink;
    }, 1000);
  };
}

/*************************************************
 * 14. GET GUEST ADDRESS LIST
 *************************************************/
function getGuestAddressList() {
  try {
    return JSON.parse(getOhnutsInfo(GUEST_ADDRESS_LIST)) || [];
  } catch {
    return [];
  }
}

/*************************************************
 * 15. GET GUEST ADDRESS BY ID
 *************************************************/
function getGuestAddressById(addressId) {
  return getGuestAddressList().find(a => a?.id === addressId) || null;
}

/*************************************************
 * 16. SAVE GUEST ADDRESS
 *************************************************/
function saveGuestAddress(newAddress) {
  let list = getGuestAddressList();
  if (newAddress?.default) {
    list.forEach(a => (a.default = false));
  }
  list.push(newAddress);
  saveOhnutsInfo(GUEST_ADDRESS_LIST, JSON.stringify(list));
}

/*************************************************
 * 17. UPDATE GUEST ADDRESS
 *************************************************/
function updateGuestAddress(address_id, updated_address) {
  let list = getGuestAddressList();
  if (updated_address?.default) {
    list.forEach(a => (a.default = false));
  }
  list = list.map(a => (a.id === address_id ? updated_address : a));
  saveOhnutsInfo(GUEST_ADDRESS_LIST, JSON.stringify(list));
}

/*************************************************
 * 18. REMOVE GUEST ADDRESS
 *************************************************/
function removeGuestAddressById(addressId) {
  const list = getGuestAddressList().filter(a => a.id !== addressId);
  saveOhnutsInfo(GUEST_ADDRESS_LIST, JSON.stringify(list));
}

/* -----------------------------------------
* 19. Get Logged-in Customer Addresses
------------------------------------------ */
function loggedCustomerAddresses() {
  const container = document.querySelector("#logged_customer_addresses");
  if (!container) return [];

  const addressesJson = container.innerHTML?.trim();
  if (!addressesJson) return [];

  try {
    const parsed = JSON.parse(addressesJson);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error(
      `[loggedCustomerAddresses] JSON parse error: ${error.message}`
    );
    return [];
  }
}

/* -----------------------------------------
* 20. Save Logged-in Customer Address
------------------------------------------ */
function saveLoggedCustomerAddress(newAddress) {
  if (!newAddress || typeof newAddress !== "object") {
    console.error("[saveLoggedCustomerAddress] Invalid address payload");
    return;
  }

  const container = document.querySelector("#logged_customer_addresses");
  if (!container) {
    console.error(
      "[saveLoggedCustomerAddress] Logged customer address container not found"
    );
    return;
  }

  let addressList = loggedCustomerAddresses();

  // Ensure only one default address
  if (newAddress.default === true) {
    addressList = addressList.map(address => ({
      ...address,
      default: false
    }));
  }

  addressList.push({
    ...newAddress,
    default: Boolean(newAddress.default)
  });

  container.innerHTML = JSON.stringify(addressList);
}

/* -----------------------------------------
*  21. Get Customer Addresses (Logged-in or Guest)
------------------------------------------ */

function getCustomerAddresses() {
  const loggedAddresses = loggedCustomerAddresses();

  if (Array.isArray(loggedAddresses) && loggedAddresses.length > 0) {
    return loggedAddresses;
  }

  const guestAddresses = getGuestAddressList();
  return Array.isArray(guestAddresses) ? guestAddresses : [];
}


/*************************************************
 * 22. CHECK OBJECT TYPE
 *************************************************/
function isObject(variable) {
  return variable !== null && typeof variable === "object" && !Array.isArray(variable);
}

/*************************************************
 * 23. CHECK EMPTY ARRAY
 *************************************************/
function isEmptyArray(arr) {
  return !Array.isArray(arr) || arr.length === 0;
}

/*************************************************
 * 24. DEBOUNCE FUNCTION
 *************************************************/
function debounce(func, delay) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => func(...args), delay);
  };
}


/*************************************************
 * 25. OBJECT EQUALITY CHECK
 *************************************************/
function areObjectsEqual(obj1, obj2) {
  if (!isObject(obj1) || !isObject(obj2)) return false;
  const keys = Object.keys(obj1);
  if (keys.length !== Object.keys(obj2).length) return false;
  return keys.every(k =>
    isObject(obj1[k]) ? areObjectsEqual(obj1[k], obj2[k]) : obj1[k] === obj2[k]
  );
}

/*************************************************
 * 26. FILTER OBJECT PROPERTIES
 *************************************************/
function filterObjectByProperties(obj, props) {
  return props.reduce((acc, key) => {
    if (key in obj) acc[key] = obj[key];
    return acc;
  }, {});
}

/*************************************************
 * 27. SLIM CART ITEMS
 *************************************************/
function getSlimCartItems(cartItems) {
  if (!Array.isArray(cartItems)) return cartItems;
  return cartItems.map(i =>
    filterObjectByProperties(i, CART_ITEM_REQUIRED_PROPERTIES)
  );
}

/*************************************************
 * 28. ADDRESS COMPLETENESS CHECK
 *************************************************/
function isAddressIncomplete(address) {
  if (!isObject(address)) return true;
  return COMPLETE_ADDRESS_REQUIRED_FIELDS.some(f => !address[f]);
}

/* =====================================================
   SHIPPING RATE → DELIVERY HELPERS
===================================================== */

/* ---------- SAFE SORT ---------- */
function sortRatesByPriceDesc(rates = []) {
  return [...rates].sort(
    (a, b) => Number(b?.price || 0) - Number(a?.price || 0)
  );
}

/* ---------- RATE → DELIVERY DAYS MAP ---------- */
function prepareShippingRateWiseDeliveryDays(shippingRates = []) {
  return shippingRates.reduce((acc, rate) => {
    if (rate?.name) acc[rate.name] = rate.delivery_days || [];
    return acc;
  }, {});
}

/* ---------- RATE → CODE MAP ---------- */
function prepareShippingRateWiseCodes(shippingRates = []) {
  return shippingRates.reduce((acc, rate) => {
    if (rate?.name) acc[rate.name] = rate.code || "";
    return acc;
  }, {});
}

/* ---------- RATE → DELIVERY INFO MAP ---------- */
function prepareShippingRateWiseDeliveryInfo(shippingRates = []) {
  const deliveryMessages = {};
  const deliveryStartDateObjects = {};

  if (!Array.isArray(shippingRates) || !shippingRates.length) {
    return { deliveryMessages, deliveryStartDateObjects };
  }

  // Sort by price ASC (Free → Expensive)
  const sortedByPriceAsc = [...shippingRates].sort(
    (a, b) => Number(a?.price || 0) - Number(b?.price || 0)
  );

  // Precompute effective delivery_range using cascading fallback
  const effectiveDeliveryRanges = {};

  for (let i = sortedByPriceAsc.length - 1; i >= 0; i--) {
    const rate = sortedByPriceAsc[i];
    const name = rate?.name;
    if (!name) continue;

    if (Array.isArray(rate?.delivery_range) && rate.delivery_range.length) {
      // ✅ Has its own delivery range
      effectiveDeliveryRanges[name] = rate.delivery_range;
    } else {
      // 🔁 Inherit from next higher-priced method
      for (let j = i + 1; j < sortedByPriceAsc.length; j++) {
        const higherRate = sortedByPriceAsc[j];
        if (
          Array.isArray(higherRate?.delivery_range) &&
          higherRate.delivery_range.length
        ) {
          effectiveDeliveryRanges[name] = higherRate.delivery_range;
          break;
        }
      }
    }
  }

  // Generate messages
  sortedByPriceAsc.forEach((rate) => {
    const name = rate?.name;
    if (!name) return;

    const { message, startDateObj } =
      generateDeliveryDaysInfo(effectiveDeliveryRanges[name]);

    deliveryMessages[name] = message;
    deliveryStartDateObjects[name] = startDateObj;
  });

  return { deliveryMessages, deliveryStartDateObjects };
}



/* ---------- DELIVERY INFO CORE ---------- */

function generateDeliveryDaysInfo(
  delivery_range,
  defaultDays = SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE
) {
  if (!Array.isArray(delivery_range) || !delivery_range.length) {
    delivery_range = defaultDays;
  }

  if (!Array.isArray(delivery_range) || !delivery_range.length) {
    return {
      message: "",
      startDateObj: null
    };
  }

  const dates = delivery_range
    .map(d => {
      if (typeof d === "string") {
        const [y, m, day] = d.split("-").map(Number);
        return new Date(y, m - 1, day); // ✅ local date
      }
      return null;
    })
    .filter(d => d instanceof Date && !isNaN(d));

  if (!dates.length) {
    return {
      message: "",
      startDateObj: null
    };
  }

  dates.sort((a, b) => a - b);

  const minDate = dates[0];
  const maxDate = dates[dates.length - 1];

  const minFmt = formatDeliveryDateFormat(minDate);
  const maxFmt = formatDeliveryDateFormat(maxDate);

  return {
    message:
      minFmt === maxFmt
        ? `Estimated Delivery: ${minFmt}`
        : `Estimated Delivery: ${minFmt} - ${maxFmt}`,
    startDateObj: minDate
  };
}


/* ---------- DATE HELPERS ---------- */
function getAdjustedDateSkippingWeekend(days) {
  if (!Number.isFinite(days)) return null;
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
}

function formatDeliveryDateFormat(date) {
  if (!isValidDateObj(date)) return " ";
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });
}
/*************************************************
 * 29. VALID DATE CHECK
 *************************************************/
function isValidDateObj(date) {
  return date instanceof Date && !isNaN(date);
}

/*************************************************
 * 30. MONEY ADDITION (FLOAT SAFE)
 *************************************************/
function addMoney(...values) {
  const cents = values.reduce((s, v) => s + Math.round(parseFloat(v) * 100), 0);
  return (cents / 100).toFixed(2);
}



/*************************************************
 * 31. REQUEST VS RESPONSE ITEM MATCH
 *************************************************/
function areRequestItemsEqualsResponseItems(requestItems, response) {
  return response?.items?.every(r =>
    requestItems.some(i => Number(i.id) === Number(r.variant_id))
  );
}

/*************************************************
 * 32. FORMAT DATE FOR CALENDAR
 *************************************************/
function formattedDateStringForCalendar(dateObj) {
  if (!isValidDateObj(dateObj)) return "";
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}


/*************************************************
 * 33. UPDATE FLATPICKR MIN DATE
 *************************************************/
function updateFlatpickrCalendarMinDate(instance, minDate) {
  instance && instance.set("minDate", minDate);
}

/*************************************************
 * 33. EMPTY CART CLEANUP
 *************************************************/
function emptyCartRemoveLocalData() {
  fetch("/cart.js")
    .then(r => r.json())
    .then(cart => {
      if (cart.item_count === 0) {
        removeOhnutsInfo(CART_TOKEN_KEY);
        removeOhnutsInfo(CART_ITEMS_KEY);
        removeOhnutsInfo(MULTI_ADDRESS_KEY);
        removeOhntsinfoVarientData();
      }
    });
}

/*************************************************
 * 34. CLEAR ALL LOCAL STORAGE
 *************************************************/
function removeOhntsinfoVarientData() {
  localStorage.clear();
}

/*************************************************
 * 35. EMPTY OBJECT CHECK
 *************************************************/
function emptyObjectChecking(obj) {
  return !isObject(obj) || Object.keys(obj).length === 0;
}
